export const roundUp = (num = 0): string => {
  if (num < 10) {
    return `0${num}`;
  }

  return `${num}`;
};
